export const LoginByCodeForm = {
  Code: 'code',
  LoginBtn: 'login-btn',
  InformativeLabel: 'informative-label',
} as const;
